import axios from "axios"
import {get} from "../../../api";
import {Flip, toast} from "react-toastify";
import {NumberFormat} from "../../../helpers/numberFormat";

export const setSolicitudes = async (value) => {
    return {type: 'solicitudes-set', payload: value}
}

export const newSolicitud = async (value) => {
    return {type: 'solicitudes-new', payload: value}
}
